import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { HeadingRegionTileFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { assertTypeName } from "../../client/guards";
import { stripHtmlTags } from "../../rich-text/utils";
import { RegionTile } from "../../regions/RegionTile";

type Props = {
  fragment: HeadingRegionTileFragment;
  headerLevelAttributeId: string;
  textAttributeId: string;
  children: React.ReactNode;
  dispatch: Dispatch<EditorAction>;
};

export function HeadingRegionTile({
  fragment,
  headerLevelAttributeId,
  textAttributeId,
  children,
  dispatch,
}: Props) {
  const { t } = useTranslation();

  const headerLevelAttribute = fragment.attributes.find(
    (a) => a.id === headerLevelAttributeId,
  );
  assertTypeName(headerLevelAttribute?.__typename === "HeaderLevelAttribute");

  const textAttribute = fragment.attributes.find(
    (a) => a.id === textAttributeId,
  );
  assertTypeName(textAttribute?.__typename === "TextAttribute");

  const onClick = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "update",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTile
      fragment={fragment}
      preview={t("HeadingRegionTile.preview", {
        level: headerLevelAttribute.level,
        text: stripHtmlTags(textAttribute.text),
      })}
      onClick={onClick}
    >
      {children}
    </RegionTile>
  );
}
